import React from 'react';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import MessageListPicker from 'Views/Page/Content/Templates/WhatIfClientTemplate/Components/MessageListPicker';
import CommentsHeader from 'Views/Page/Content/Templates/WhatIfClientTemplate/Components/CommentsHeader';
import { useCommentLayoutContext } from 'Views/Page/Content/Templates/WhatIfClientTemplate/CommentLayoutProvider';
import Footer from './Footer';

const ThreadTemplate = () => {
  const { threadResource } = useCommentLayoutContext();

  return (
    <VerticalStack height={'screen'}>
      <StackItem unshrinkable position={'top'}>
        <CommentsHeader />
      </StackItem>
      <StackItem fillsSpace scrollable>
        <VerticalStack>
          <StackItem fillsSpace />
          <MessageListPicker threadResource={threadResource} />
        </VerticalStack>
      </StackItem>
      <StackItem position={'bottom'} unshrinkable>
        <Footer />
      </StackItem>
    </VerticalStack>
  );
};

export default ThreadTemplate;
